import { createUseStyles } from 'react-jss';
import { Theme } from '@wds/styles';

const useStyles = createUseStyles((theme: Theme) => ({
  outline: {
    minHeight: '100vh',
    maxWidth: 390,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  contentOutline: {
    padding: [[0, 0, theme.spacing[7], 0]],
  },
  // Screen width for big screens
  '@media (min-width: 1024px)': {
    outline: { maxWidth: 650 },
  },
  // Responsive
  // 375px to 479px
  '@media (max-width: 479px)': {
    outline: { maxWidth: 342 },
  },
  // 374px and below
  '@media (max-width: 374px)': {
    outline: { maxWidth: 272 },
  },
}));

export default useStyles;
